import React from "react";
import { IconButton } from "@mui/material";
import { Link } from "react-router";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { isPlainLeftClick } from "@common/isPlainLeftClick";

const tooltipMaxWidth = 400;

export interface ITaskNavigationLinkButton {
    linkTo: string | undefined;
    tooltip: React.ReactNode;
    onNavigate: () => void;
    color?: "primary" | "default";
    children: React.ReactElement;
}

// A real anchor to the task's deep link, so the browser offers "open in new tab", middle-click and ctrl-click.
// A plain left click is intercepted and steps in place instead, leaving the dialog and the page behind it as they are.
function TaskNavigationLinkButton(props: ITaskNavigationLinkButton) {
    if (!props.linkTo) {
        return (
            <IconButton size="small" disabled>
                {props.children}
            </IconButton>
        );
    }

    return (
        <DotLegalTooltip toolTipMaxWidth={tooltipMaxWidth} text={props.tooltip}>
            <IconButton
                size="small"
                color={props.color}
                component={Link}
                to={props.linkTo}
                onClick={(event: React.MouseEvent) => {
                    if (isPlainLeftClick(event)) {
                        event.preventDefault();
                        // Stepping stays inside the pane, so the panel must not take this for a navigation away.
                        event.stopPropagation();
                        props.onNavigate();
                    }
                }}
            >
                {props.children}
            </IconButton>
        </DotLegalTooltip>
    );
}

export default TaskNavigationLinkButton;
